/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Could_Not_Load_VoicesInputs */

const en_mobile_could_not_load_voices = /** @type {(inputs: Mobile_Could_Not_Load_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load voices. Check your connection and try again.`)
};

const es_mobile_could_not_load_voices = /** @type {(inputs: Mobile_Could_Not_Load_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las voces. Revisa tu conexión e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Couldn't load voices. Check your connection and try again." |
*
* @param {Mobile_Could_Not_Load_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_could_not_load_voices = /** @type {((inputs?: Mobile_Could_Not_Load_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Could_Not_Load_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_could_not_load_voices(inputs)
	return en_mobile_could_not_load_voices(inputs)
});